import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { removeNullProperties } from 'src/utils/object'
import { generate } from 'src/utils/urls'
import { parse, QueryParams } from 'src/utils/urlUtils'

const useQueryParams = <T = any>() => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = parse<T>(location.search)

  const setQueryParams = useCallback(
    (nextQueryParams: QueryParams | ((qp: QueryParams) => QueryParams), append = true) => {
      navigate(
        generate(
          removeNullProperties(
            append
              ? {
                  ...parse(location.search),
                  ...nextQueryParams,
                }
              : nextQueryParams,
          ),
          location.pathname,
        ),
      )
    },
    [navigate, location.search, location.pathname],
  )

  return { queryParams, setQueryParams }
}

export default useQueryParams
